// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1P72w","title":"BackImages_title__3Dgi3","images":"BackImages_images__vnHQw"};